exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".st0[data-v-a0dc9b30]{fill:#f64444}.st1[data-v-a0dc9b30]{fill:#373145}", ""]);

// exports
